import React, { Component } from "react";
import "./SpecialSelectBanners.css";
import SpecialSelectBannerItem from "./SpecialSelectBannerItem";
import SpecialSelectBannersItemList from "./SpecialSelectBannersItemList";

class SpecialSelectBanners extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { banners } = this.props;

    if (banners === null || banners.length === 0) return null;

    return (
      <div className="row equal-height-row">
        <div className="col-xs-12 col-sm-6 special-select-banner-first-items-col">
          <SpecialSelectBannerItem
            banner={banners[0]}
            style={{ marginBottom: 0}}
            className={"feature-item"}
          />
        </div>

        <div className="col-xs-12 col-sm-6" style={{ padding: 0 }}>
          <SpecialSelectBannersItemList banners={banners.slice(1)} />
        </div>
      </div>
    );
  }
}

export default SpecialSelectBanners;
